export default __webpack_public_path__ + "static/media/up.bd4b9fd7.png";